import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        isOrLogin:localStorage.getItem("isOrLogin") || "",
        // imageUrls1:JSON.parse(localStorage.getItem("userInfo")) || "",
    },
    mutations: {
        //是否登录
        ISLOGIN(state,str){
            localStorage.setItem('isOrLogin', str);
            state.isOrLogin = str;
        }
    },
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js